interface InfoCircleIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

export default function InfoCircleIcon({
  width = 22,
  height = 22,
  color = '#4F55FD',
  className,
}: InfoCircleIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.9999 11.0004L10.9999 15.8004M10.9999 7.44258V7.40039M1.3999 11.0004C1.3999 5.69846 5.69797 1.40039 10.9999 1.40039C16.3018 1.40039 20.5999 5.69846 20.5999 11.0004C20.5999 16.3023 16.3018 20.6004 10.9999 20.6004C5.69797 20.6004 1.3999 16.3023 1.3999 11.0004Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
